import { render, staticRenderFns } from "./reportageIntroduction.vue?vue&type=template&id=089bcb84&"
import script from "./reportageIntroduction.vue?vue&type=script&lang=js&"
export * from "./reportageIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./reportageIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports